import { cn } from "@car/ui/lib/utils"

function Skeleton({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-muted motion-reduce:animate-none", className)}
      {...props}
    >
      {/* صفحه‌خوان به‌جای سکوت «در حال بارگذاری» می‌شنود؛ از چند اسکلت هم‌سطح فقط اولی گفته می‌شود */}
      {children ?? (
        <span className="sr-only [[data-slot=skeleton]~[data-slot=skeleton]>&]:hidden">
          در حال بارگذاری…
        </span>
      )}
    </div>
  )
}

export { Skeleton }
